import ModelFactory from "../ModelFactory.js";
import PercentageDeviationType from "./PercentageDeviationType.js";
import ValueDeviationType from "./ValueDeviationType.js";

/**
 * Create instances of the subclasses of {@link AbstractDeviationType}.
 */
class DeviationTypeFactory extends ModelFactory {
	allClasses() {
		return [ValueDeviationType, PercentageDeviationType];
	}

	makeAll() {
		return this.allClasses().map(
			(DeviationTypeClass) => new DeviationTypeClass(),
		);
	}
}

const deviationTypeFactory = new DeviationTypeFactory();

export default deviationTypeFactory;
